module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/pr-276.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/contribution/pr.md
// module id = 719
// module chunks = 410